import { create } from "zustand";
import { apiRequest } from "services/api";
import { SystemSettingsModel } from "./model";

export interface SystemSettingsStateModel {
  data: SystemSettingsModel[] | null;
  loading: boolean;
  error: null;
}

interface SystemSettingsStore extends SystemSettingsStateModel {
  list: () => Promise<void>;
  batchUpdate: (objects: any) => Promise<void>;
}

export const useSystemSettingsStore = create<SystemSettingsStore>((set, get) => ({
  data: null,
  loading: false,
  error: null,

  list: async () => {
    set({ loading: true });
    try {
      const data = await apiRequest({
        endpoint: "/system-settings/",
        method: "get",
      });
      set({ data, loading: false });
    } catch (_error) {
      set({ loading: false });
    }
  },

  batchUpdate: async (objects) => {
    try {
      await apiRequest({
        endpoint: "/system-settings/",
        method: "patch",
        payload: { objects },
      });
      await get().list();
      const { useNotificationStore } = await import("modules/notifications/store");
      useNotificationStore.getState().successNotification("System settings updated!");
    } catch (_error) {
      // error silently
    }
  },
}));
